import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  // Данные по направлениям
  stock_directions: [],
  // Флаг получения данных
  stock_directions_fetching: false
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
